import React, { Component, createRef } from 'react';
import './index.css';
import { withTranslation } from '../../lib/translate';
import { NormalText } from '../common';

class ScrollTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            heightDifference: 0,
            activeTab: 0,
        };
        this.lastTabRef = createRef();
        this.contentRef = createRef();
        this.tabsRef = createRef();
        this.tabsContent = [];
    }

    componentDidMount() {
        setTimeout(() => {
            const parent = this.props.parent?.current;
            if (!parent) return;

            this.tabsContent = Array.from(this.contentRef.current.children);

            this.setState({
                heightDifference: parent.clientHeight - this.lastTabRef.current.clientHeight - 64,
            });

            parent.addEventListener('scroll', this.handleScroll);
        }, 100);
    }

    componentWillUnmount() {
        const parent = this.props.parent?.current;
        parent?.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        if (this.ignoreScroll) return;

        const parent = this.props.parent?.current;
        if (!parent) return;

        const offset = 60;
        const scrollTop = parent.scrollTop;

        for (let i = 0; i < this.tabsContent.length; i++) {
            const el = this.tabsContent[i];
            const parentRect = parent.getBoundingClientRect();
            const elRect = el.getBoundingClientRect();
            const elTop = scrollTop + elRect.top - parentRect.top - offset;
            const elBottom = elTop + el.offsetHeight;

            if (scrollTop >= elTop && scrollTop < elBottom) {
                if (this.state.activeTab !== i) {
                    this.setState({ activeTab: i });
                }
                break;
            }
        }
    };

    handleTabClick = (index) => {
        const parent = this.props.parent?.current;
        const tab = document.querySelector(`#tab_${index}`);
        const offset = 60;

        if (tab && parent) {
            this.ignoreScroll = true;

            const parentRect = parent.getBoundingClientRect();
            const tabRect = tab.getBoundingClientRect();
            const scrollTop = parent.scrollTop + tabRect.top - parentRect.top - offset;

            parent.scrollTo({ top: scrollTop, behavior: 'smooth' });

            setTimeout(() => {
                this.ignoreScroll = false;
                this.setState({ activeTab: index });
            }, 500);
        }
    };

    render() {
        const tabs = this.props.tabs || [];

        return (
            <div className="scrollable-tabs-wrapper">
                <div ref={this.tabsRef} className="scrollable-tabs-header">
                    {tabs.map((tab, index) => (
                        <NormalText
                            key={`tabs-header_${index}`}
                            className={this.state.activeTab === index ? 'scrollable-tabs-button-active' : ''}
                            onClick={() => this.handleTabClick(index)}
                            fill="clear"
                        >
                            {tab.title}
                        </NormalText>
                    ))}
                </div>

                <div
                    ref={this.contentRef}
                    style={{ paddingBottom: `${this.state.heightDifference}px` }}
                    className="scrollable-tabs-content"
                >
                    {tabs.map((tab, index) => (
                        <div
                            key={`tabs-content_${index}`}
                            id={`tab_${index}`}
                            ref={index + 1 === tabs.length ? this.lastTabRef : null}
                        >
                            {tab.content}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default withTranslation(ScrollTabs);
